import { useLocation, useNavigate } from 'react-router-dom'

// The CRM page a person was opened from, for Person Detail's Back when it
// can't pop history. Kept per tab in sessionStorage, which window.open copies
// into the Calculate / quote tabs the person page opens.
const ORIGIN_KEY = 'crmPersonOrigin'
const CRM_ORIGINS = ['/crm/pipeline', '/crm/people', '/crm/reports']

export const crmOrigin = () => {
    try {
        const origin = sessionStorage.getItem(ORIGIN_KEY)
        if (CRM_ORIGINS.includes(origin)) return origin
    } catch (e) {
        // storage blocked: fall through to the board
    }
    return '/crm/pipeline'
}

const rememberCrmOrigin = (pathname) => {
    if (!CRM_ORIGINS.includes(pathname)) return
    try {
        sessionStorage.setItem(ORIGIN_KEY, pathname)
    } catch (e) {
        // storage blocked: Back falls back to the board
    }
}

// Single entry point for opening a Person's detail: every list row / board card
// routes to the full-page detail view, on every viewport. Kept as a hook so the
// route lives in one place rather than at each caller.
export const useOpenPerson = () => {
    const navigate = useNavigate()
    const { pathname } = useLocation()

    return (id) => {
        if (!id) return
        rememberCrmOrigin(pathname)
        navigate(`/crm/people/${id}`)
    }
}
